// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from 'app/components/CRUD/EditEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/**
 * Both dropdowns are pre-selected from the fetched row: EditEntity seeds each
 * dropdown from data[<dropdown name>], and the API returns
 * fare_media_issuer_id / organisation_id on GET /:id.
 *
 * Re-pointing an assignment that has already issued cards is refused by the API
 * with a translated 409 — changing it would silently re-attribute every card
 * issued under it, so the correct action is a new assignment. A non-super-admin
 * also cannot move a row to a different organisation; the API pins it to theirs.
 */
const UpdateFareMediaIssuerOrganization: React.FC = () => {
  const dropdowns = [
    {
      name: 'fare_media_issuer_id',
      labelKey: 'FareMediaIssuer',
      required: true,
      apiUrl: CONFIG_PATHS.fareMediaIssuersLookup,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_issuer_name',
        labelKeyAr: 'ar_issuer_name',
      },
    },
    {
      name: 'organisation_id',
      labelKey: 'Organisation',
      required: true,
      apiUrl: CONFIG_PATHS.organisations,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name',
      },
    },
  ];

  const buildUpdatePayload = formValues => ({
    fare_media_issuer_id: formValues.fare_media_issuer_id,
    organisation_id: formValues.organisation_id,
  });

  return (
    <EditEntity
      pageTitle="EditFareMediaIssuerOrganization"
      fetchApiUrl={CONFIG_PATHS.fareMediaIssuerOrganisationById}
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={[]}
      dropdowns={dropdowns}
      buildUpdatePayload={buildUpdatePayload}
      updateApiUrl={CONFIG_PATHS.fareMediaIssuerOrganisationById}
      updateApiMethod="PATCH"
      successMessage="FareMediaIssuerOrganizationUpdatedSuccessfully"
      // EditEntity redirects to backUrl on save, so this lands on the detail page.
      backUrl={`${CONFIG_ROUTES.fareMediaIssuerOrganisations}/:id`}
      subsystemName="FareMediaIssuersOrganisations"
      permissionSystem="masterConfig"
    />
  );
};

export default UpdateFareMediaIssuerOrganization;
